import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Button } from '@sumup-oss/circuit-ui';
import { ChevronDown } from '@sumup-oss/icons';

import { StyledComponentsParams } from 'types/components';

export const ExpandableAccordionContainer = styled('div')(
  ({ isOpened }: StyledComponentsParams & { isOpened: boolean }) => css`
    overflow: hidden;
    visibility: ${isOpened ? 'visible' : 'hidden'};
    max-height: ${isOpened ? 'fit-content' : '0'};
    transition: all 0.3s ease-in-out;
  `,
);

export const AccordionContent = styled('div')(
  ({ theme }: StyledComponentsParams) => css`
    margin: 0 ${theme.spacings.kilo} ${theme.spacings.giga};
    z-index: ${theme.zIndex.absolute};
    cursor: default;

    & > :first-child {
      margin-top: ${theme.spacings.giga};
    }
  `,
);

export const AccordionElement = styled('div')(
  () => css`
    padding: 0;
    background-color: var(--cui-bg-normal);
    box-shadow: none;
    border-bottom: 2px solid var(--cui-bg-normal-pressed);
    &:hover,
    &:after,
    &:focus:after,
    &:hover:after,
    &:focus:after {
      box-shadow: none;
    }
    &:after {
      z-index: -1;
    }
  `,
);

export const AccordionIcon = styled(({ isOpened, ...rest }) => (
  <ChevronDown {...rest} />
))(
  ({ theme, isOpened }: StyledComponentsParams & { isOpened: boolean }) => css`
    min-width: ${theme.iconSizes.kilo};
    min-height: ${theme.iconSizes.kilo};
    transform: ${isOpened ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: all 0.3s ease-in-out;
  `,
);

export const AccordionTitle = styled(Button)(
  ({ theme }: StyledComponentsParams) => css`
    position: relative;
    border: none;
    width: 100%;
    z-index: ${theme.zIndex.default};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.spacings.kilo};
    text-align: left;
    &:hover {
      background-color: var(--cui-bg-normal);
    }
    span:last-child {
      width: 100%;
      display: flex;
      justify-content: space-between;

      & p {
        max-width: calc(100% - ${theme.spacings.giga});
      }
    }
  `,
);
